import { Pipe, PipeTransform } from '@angular/core';

import { TimezoneTagToNameMap } from '@sondermind/utilities/time-and-date';

@Pipe({
  name: 'providerTimeZoneString',
  standalone: true,
})
export class ProviderTimeZoneStringPipe implements PipeTransform {
  transform(timeZone: string): string {
    if (timeZone) {
      const timezoneName = TimezoneTagToNameMap[timeZone];
      if (timezoneName) {
        const dateStr = new Date().toLocaleTimeString(undefined,
          { timeZone, timeZoneName: 'short' }
        ).split(' ');
        // The last part of the locale time string is the timezone
        const timezoneAbbrev = dateStr[dateStr.length - 1];

        return `${timezoneName} (${timezoneAbbrev})`;
      }
    }

    return 'Timezone unknown';
  }
}
